export const openLink = (reqUrl,whId,clientCode,user,token) => {
  document.getElementById("reportFrame").style.display = "block";
  var postData = document.createElement("form");
  postData.method = "post";
  postData.action = reqUrl;
  postData.target = "reportFrame";//用来将数据提交到frame1上

  var input_whId = document.createElement("whId");
  input_whId.type = "hidden";
  input_whId.name = "whId";
  input_whId.value = whId;
  postData.appendChild(input_whId);

  var input_clientCode = document.createElement("clientCode");
  input_clientCode.type = "hidden";
  input_clientCode.name = "clientCode";
  input_clientCode.value = clientCode;
  postData.appendChild(input_clientCode);

  var input_user = document.createElement("user");
  input_user.type = "hidden";
  input_user.name = "user";
  input_user.value = user;
  postData.appendChild(input_user);

  var input_token = document.createElement("token");
  input_token.type = "hidden";
  input_token.name = "token";
  input_token.value = token;
  postData.appendChild(input_token);

  document.body.appendChild(postData);
  postData.submit();

  //用完之后，不要忘记删掉
  // postData.removeChild(input_whId);
  // postData.removeChild(input_clientCode);
  // postData.removeChild(input_user);
  // postData.removeChild(input_token);
  // document.body.removeChild(postData);
}



// WEBPACK FOOTER //
// ./src/http/moudules/openLink.js